import { reactionsState } from './reactionsState';

export const clearPendingReactionUpdates = () => {
  reactionsState.setValue({
    ...reactionsState.value,
    pendingUpdates: {},
  });
};
